/*********************************************************************************************
 * Initialize the sticky CTA behavior.
 */
function initStickyCTA() {
	let dernierePositionDeScrollConnue = 0;
	let ticking = false;
	const CTA = document.querySelector(".mm-main-product-button-container");

	if (CTA) {
		const CTA_position = CTA.offsetTop - window.innerHeight / 3;

		/**
		 * Add or remove the sticky class to the CTA based on scroll position.
		 *
		 * @param {number} position_scroll - The current scroll position.
		 */
		function toggleStickyCTA(position_scroll) {
			if (position_scroll > CTA_position) {
				CTA.classList.add("mm-cta-sticky");
			} else {
				CTA.classList.remove("mm-cta-sticky");
			}
		}

		window.addEventListener("scroll", () => {
			dernierePositionDeScrollConnue = window.scrollY;

			if (!ticking) {
				ticking = true;

				window.requestAnimationFrame(() => {
					toggleStickyCTA(dernierePositionDeScrollConnue);
					ticking = false;
				});
			}
		});
	}
}

/*********************************************************************************************
 * Initialize the Splide carousel for the main product slider.
 */
function mmSlideProduct() {
	var splideElemMain = document.querySelector("#main-slider");

	if (splideElemMain) {
		var main = new Splide(splideElemMain, {
			type: "loop",
			pagination: false,
			arrows: true,
			perPage: 1,
			destroy: true,
			breakpoints: {
				768: {
					destroy: false,
					padding: {
						right: 40,
					},
				},
			},
		});
		main.mount();
	}
}

/************************************************************************************************/
// Class for handling variant selection
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");
		this.addEventListener("change", this.onVariantChange);
	}

	/*********************************************************************************************
	 * Handle variant change event.
	 */
	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			this.variantFetch();
			mmCloseD();
		}
	}

	/*********************************************************************************************
	 * Get selected options from the variant checkboxes.
	 */
	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	/*********************************************************************************************
	 * Get variant data from the embedded JSON.
	 *
	 * @returns {Object} - The variant data.
	 */
	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	/*********************************************************************************************
	 * Get the selected variant based on selected options.
	 */
	getSelectedVariant() {
		const options = this.options;
		this.currentVariant = this.getVariantJSON().find((variant) => {
			return options.every((option, index) => option === variant.options[index]);
		});
	}

	/*********************************************************************************************
	 * Update the URL to include the selected variant ID.
	 */
	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	/*********************************************************************************************
	 * Fetch variant data from the server and cache it.
	 */
	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	/*********************************************************************************************
	 * Render variant information in the DOM.
	 *
	 * @param {Document} html - The HTML document containing the variant information.
	 */
	renderVariantInfo(html) {
		this.updateElementOuter("#product_id", html);
		this.updateElementOuter(".mm-product-price", html);
		this.updateElementOuter(".mm-product-variants", html);
		this.updateElementOuter(".mm-product-cta", html);
		this.updateElementOuter(".mm-product-variants-picker", html);
		this.updateElementOuter(".mm-product-form-variant-value", html);
		this.updateElementOuter(".mm-product-form-sku", html);
		this.updateElementOuter(".mm-main-product-label-special", html);
		this.updateElementOuter(".mm-product-stock-left-container", html);
		this.updateElementOuter(".mm-product-CTA-container", html);
		this.updateQuantity(html);
	}

	/*********************************************************************************************
	 * Update the inner HTML of an element.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	/*********************************************************************************************
	 * Update the outer HTML of an element.
	 *
	 * @param {string} selector - The CSS selector of the element to update.
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	/*********************************************************************************************
	 * Update the quantity input and buttons based on the selected variant.
	 *
	 * @param {HTMLElement} html - The HTML element containing the new content.
	 */
	updateQuantity(html) {
		const quantityInput = this.container.querySelector('input[name="quantity"]');
		const newQuantityInput = html.querySelector('input[name="quantity"]');

		if (quantityInput && newQuantityInput) {
			const maxQuantity = newQuantityInput.getAttribute("data-max");
			quantityInput.setAttribute("max", maxQuantity);
			quantityInput.setAttribute("data-max", maxQuantity);

			quantityInput.value = 1;

			const decreaseButton = this.container.querySelector(`[onclick="mmChangeQtty(-1, '${quantityInput.id}')"]`);
			const increaseButton = this.container.querySelector(`[onclick="mmChangeQtty(1, '${quantityInput.id}')"]`);

			if (decreaseButton) {
				decreaseButton.disabled = true;
			}

			if (increaseButton) {
				increaseButton.disabled = parseInt(maxQuantity) <= 1;
			}
		}
	}
}

/************************************************************************************************/
// Define the custom element
customElements.define("variant-selector", VariantSelector);

/************************************************************************************************/
// Loaded Listenner
document.addEventListener("DOMContentLoaded", () => {
	mmSlideProduct();
	// mmSlideProductReassurance();
	initStickyCTA();
});

/************************************************************************************************/
// Change quantity
function mmChangeQtty(change, inputId) {
	var input = document.getElementById(inputId);
	var currentQuantity = parseInt(input.value);
	var maxQuantity = parseInt(input.getAttribute("data-max"));

	var newQuantity = currentQuantity + change;

	if (newQuantity >= 1 && newQuantity <= maxQuantity) {
		input.value = newQuantity;

		var decreaseButton = document.querySelector(`[onclick="mmChangeQtty(-1, '${inputId}')"]`);
		var increaseButton = document.querySelector(`[onclick="mmChangeQtty(1, '${inputId}')"]`);

		decreaseButton.disabled = newQuantity <= 1;
		increaseButton.disabled = newQuantity >= maxQuantity;
	}
	mmUpdatePrice(newQuantity);
}

/*********************************************************************************************
 * Update the displayed prices based on the new quantity.
 *
 * @param {number} qtty - The current product quantity used to calculate the prices.
 */
function mmUpdatePrice(qtty) {
	var priceAll = document.querySelectorAll("[data-price]");
	var comparePriceAll = document.querySelectorAll("[data-compare-price]");

	// Met à jour les prix normaux
	priceAll.forEach(function (price) {
		var priceValue = parseFloat(price.dataset.price);
		if (!isNaN(priceValue)) {
			var calculatedPrice = (priceValue * qtty) / 100;
			price.innerHTML = calculatedPrice % 1 === 0 ? Math.floor(calculatedPrice) + " €" : calculatedPrice.toFixed(2) + " €";
		} else {
			console.error("Valeur de prix non valide : ", price.dataset.price);
		}
	});

	// Met à jour les prix comparatifs
	comparePriceAll.forEach(function (comparePrice) {
		var comparePriceValue = parseFloat(comparePrice.dataset.comparePrice);
		if (!isNaN(comparePriceValue)) {
			var calculatedComparePrice = (comparePriceValue * qtty) / 100;
			comparePrice.innerHTML = calculatedComparePrice % 1 === 0 ? Math.floor(calculatedComparePrice) + " €" : calculatedComparePrice.toFixed(2) + " €";
		} else {
			console.error("Valeur de prix comparatif non valide : ", comparePrice.dataset.comparePrice);
		}
	});
}

/************************************************************************************************/
// PRODUCT FORM PANEL
function mmOpenD(optionName) {
	const panel = document.querySelector(`.mm-product-form-panel-wrapper-${optionName}`);
	if (panel) {
		panel.classList.remove("mm-hidden");
		document.querySelector("html").classList.add("stop-scrolling");
	} else {
		console.error(`Panel not found: .mm-product-form-panel-wrapper-${optionName}`);
	}
}

function mmCloseD() {
	document.querySelectorAll(".mm-product-form-panel-wrapper").forEach((panel) => {
		panel.classList.add("mm-hidden");
	});
	document.querySelector("html").classList.remove("stop-scrolling");
}
